import { featureFlags } from "#/config/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useBridgeFeatureFlag = () => {
  const isBridgeDisabled =
    useFeatureFlags<boolean>(featureFlags.disableBridge) || false;

  return {
    isBridgeDisabled,
  };
};
